module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c(_vm.currentView, {
    tag: "component",
    attrs: {
      "params": _vm.params
    },
    on: {
      "callBusinessRule": _vm.callBusinessRule
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43c8c53c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/sgs/SgsRenderCustomComponent.vue
// module id = 917
// module chunks = 2